import { SlotOptions } from '@mbrtargeting/metatag-publisher-api';
import { AdLabel, AdLabelOrientation } from '@mbrtargeting/metatag-shared-modules';


// css classes are found in websiteConfigurations -> global/global.json
const METATAG_DEFAULTS = {
    text: 'Anzeige',
    disable: false,
    unfilled: false,
    political: false,
    orientation: AdLabelOrientation.horizontal,
    elementId: 'sdgAnzeige',
    cssClassAdLabel: 'sdgAnzeigenkennung',
    cssClassHideAdLabel: 'sdgHideLabel',
    cssClassDisableAdLabel: 'sdgDisableLabel',
    cssClassPoliticalAdLabel: 'sdgPoliticalAdLabel',
    cssClassOrientation: {
        [AdLabelOrientation.horizontal]: 'sdgAdLabelHorizontal',
        [AdLabelOrientation.verticalLeft]: 'sdgAdLabelVerticalLeft',
        [AdLabelOrientation.verticalRight]: 'sdgAdLabelVerticalRight',
    },
};

interface CreateAdLabelOptions {
    slotName: string;
    options: SlotOptions;
}

export const createAdLabel = ({ slotName, options }: CreateAdLabelOptions) => {

    const { adLabelOrientation, showAdvertLabel } = options;

    return new AdLabel({
        ...METATAG_DEFAULTS,
        orientation: AdLabelOrientation[adLabelOrientation],
        hide: !showAdvertLabel,
        cssClassSlotName: `sdgAnz-${slotName}`,
        elementId: `sdg_${slotName}_anz`,
    });
}
